<template>
  <q-dialog v-model="show" persistent>
    <q-card class="bg-white text-black form-dialog" style="min-width: 320px; max-width: 500px; width: 100%;">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6 text-weight-bold flex items-center text-black">
          <q-icon name="cable" color="primary" class="q-mr-sm" size="24px" />
          {{ $t('userPanel.apiIntegrations.newIntegration') }}
        </div>
        <q-space />
        <q-btn icon="close" flat round dense v-close-popup class="text-grey-7" />
      </q-card-section>

      <q-form ref="form" @submit="handleSubmit">
        <q-card-section class="q-gutter-md q-pt-md">
          <div>
            <q-input
              v-model="form.name"
              label-color="grey-7"
              :label="$t('userPanel.apiIntegrations.name') + ' *'"
              :hint="$t('userPanel.apiIntegrations.nameHint')"
              color="primary"
              lazy-rules
              :rules="[val => !!val || $t('validation.required'), val => val.length <= 255 || $t('userPanel.apiIntegrations.error.tooLong')]"
            />
          </div>

          <div class="q-mt-lg">
            <q-input
              v-model="form.domain"
              label-color="grey-7"
              :label="$t('userPanel.apiIntegrations.domain') + ' *'"
              :hint="$t('userPanel.apiIntegrations.domainHint')"
              color="primary"
              lazy-rules
              :rules="[val => !!val || $t('validation.required'), val => val.length <= 255 || $t('userPanel.apiIntegrations.error.tooLong')]"
            />
          </div>

          <div class="q-mt-lg border-box q-pa-md rounded-borders bg-grey-2 flex justify-between items-center">
            <div class="flex-column" style="max-width: 75%;">
              <div class="text-subtitle2 text-weight-bold text-black">{{ $t('userPanel.apiIntegrations.showAllEvents') }}</div>
              <div class="text-caption text-grey-7 q-mt-xs">{{ $t('userPanel.apiIntegrations.showAllEventsHint') }}</div>
            </div>
            <q-toggle v-model="form.show_all_events" color="primary" />
          </div>
        </q-card-section>

        <q-card-actions align="right" class="q-pa-md">
          <q-btn flat :label="$t('userPanel.apiIntegrations.cancel')" color="grey-7" v-close-popup />
          <q-btn :loading="submitting" :label="$t('userPanel.apiIntegrations.create')" color="primary" type="submit" class="q-px-md" />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: "ApiIntegrationFormDialog",
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        name: "",
        domain: "",
        show_all_events: false
      }
    };
  },
  computed: {
    show: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    }
  },
  watch: {
    modelValue(newVal) {
      if (newVal) {
        this.resetForm();
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$emit("submit", { ...this.form });
    },
    resetForm() {
      this.form.name = "";
      this.form.domain = "";
      this.form.show_all_events = false;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-dialog {
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.border-box {
  border: 1px solid rgba(0, 0, 0, 0.06);
  background-color: #f9f9f9;
}
</style>
